import React, { useState } from 'react';
import styles from '../../Patient.module.css';
import { useDispatch, useSelector } from 'react-redux';
import inputStyles from '../../../ManagementPages.module.css';
import { showAlert } from '../../../../components/PerinHealthAlertSlice';
import { customStyles } from '../../../../components/AccountManagement/CustomStyles';
import Select from 'react-select';

const PersonalInfoDetail= ({ setModal, setUpdateFn, setCancelFn }) => {

    const dispatch = useDispatch();
    const dropdowns = useSelector((state) => state.dropdowns);
    const patient = useSelector((state)=>state.patient);
    const {firstName, lastName, email, countryCode, phone, address} = patient;
    const [showUpdateButtons, setShowUpdateButtons] = useState(false);
    const initialState = {
        firstName: firstName,
        lastName: lastName ,
        email: email,
        countryCode: countryCode,
        phone: phone,
        address: {
            type: address.type || "",
            address1: address.address1 || "",
            address2: address.address2 || "",
            city: address.city || "",
            state: address.state || "",
            country: address.country || "",
            zip: address.zip || "",

        }
    };
    const [ updatedInfo, setUpdatedInfo ] = useState(initialState);

    const [displayPhoneCountryCode, setDisplayPhoneCountryCode] = useState(() => {
        const countryCodeMatch = dropdowns.countries.find((code)=>code.phoneCountryCode === updatedInfo.countryCode)
        if (countryCodeMatch && updatedInfo.countryCode !== "") {
            return {value: countryCodeMatch.phoneCountryCode, label: `${countryCodeMatch.phoneCountryCode} (${countryCodeMatch.name})`}
        } else return {value:'', label: ''}
    });

    const [displayCountry, setDisplayCountry] = useState(() => {
        const selectedCountry = dropdowns.countries.find(country => country.code === updatedInfo.address.country);
        return selectedCountry ? { value: selectedCountry.code, label: selectedCountry.name } : { value: '', label: '' };
    });

    const [displayState, setDisplayState] = useState(() => {
        const selectedCountry = dropdowns.countries.find(country => country.code === updatedInfo.address.country);
        const selectedState = selectedCountry?.states.find(state => state.code === updatedInfo.address.state);
        return selectedState ? { value: selectedState.code, label: selectedState.name } : { value: '', label: '' };
    });

    const handleCountry = (selected) => {
        handleDropdownChange("country", selected.value, true);
        handleDropdownChange("state", "", true);
        setDisplayState({ value: '', label: '' })
        setDisplayCountry(selected);
    };

    const handleState = (selected) => {
        handleDropdownChange("state", selected.value, true);
        setDisplayState(selected);
    };

    const handlePhoneCountryCode = (selected) => {
        handleDropdownChange("countryCode", selected.value, false);
        setDisplayPhoneCountryCode(selected);
    };

    const handleDropdownChange = (id, value, address) => {
        const tempData = {...updatedInfo};
        if (address) {
            tempData.address[id] = value;
        } else {
            tempData[id] = value;
        }
        setUpdatedInfo(tempData);
        if (!showUpdateButtons) {
            setShowUpdateButtons(true);
        }
    };

    const handleChange = (e) => {
        const { id, value } = e.target;
        const tempData = {...updatedInfo};
        tempData[id] = value;
        setUpdatedInfo(tempData);
        if (!showUpdateButtons) {
            setShowUpdateButtons(true);
        }
    };

    const handleAddressChange = (e) => {
        const { id, value } = e.target;
        const tempData = {...updatedInfo};
        tempData.address[id] = value;
        setUpdatedInfo(tempData);
        if (!showUpdateButtons) {
            setShowUpdateButtons(true);
        }
    };

    const handleUpdate = () => {
        const updatingInfo = {
            ...patient,
            ...updatedInfo,
        };
        const updateFn = () => {
            dispatch(
                showAlert({
                    header: "Success",
                    message: "Personal Info updated",
                    type: 'success',
                })
            );
            setShowUpdateButtons(false);
        }
        setUpdateFn(()=>updateFn);
        setCancelFn(()=>handleCancel);
        setModal({title:"Personal Info", message:`Update ${firstName} ${lastName}'s personal info?`, data:updatingInfo});
    };

    const handleCancel = () => {
        setUpdatedInfo(initialState);
        setShowUpdateButtons(false);

        const countryCodeMatch = dropdowns.countries.find(
            (code) => code.phoneCountryCode === initialState.countryCode
        );
        if (countryCodeMatch && initialState.countryCode !== "") {
            setDisplayPhoneCountryCode({
                value: countryCodeMatch.phoneCountryCode,
                label: `${countryCodeMatch.phoneCountryCode} (${countryCodeMatch.name})`
            });
        } else {
            setDisplayPhoneCountryCode({ value: '', label: '' });
        }

        const selectedCountry = dropdowns.countries.find(country => country.code === initialState.address.country);
        const oldCountryVal =  selectedCountry ? { value: selectedCountry.code, label: selectedCountry.name } : { value: '', label: '' };
        setDisplayCountry(oldCountryVal);

        const selectedState = selectedCountry?.states.find(state => state.code === initialState.address.state);
        const oldStateVal = selectedState ? { value: selectedState.code, label: selectedState.name } : { value: '', label: '' };
        setDisplayState(oldStateVal);
    };

    return (
        <div style={{display:"flex", flexDirection:"column", gap:"15px"}}>
            <div className={inputStyles["styled-input-container"]}>
                <input
                    id="firstName"
                    style={{width:"300px"}}
                    value={updatedInfo.firstName}
                    onChange={handleChange}
                ></input>
                <label className={updatedInfo.firstName && inputStyles['filled']}>
                    First Name*
                </label>
            </div>
            <div className={inputStyles["styled-input-container"]}>
                <input 
                    id="lastName"
                    style={{width:"300px"}}
                    value={updatedInfo.lastName}
                    onChange={handleChange}
                ></input>
                <label className={updatedInfo.lastName && inputStyles['filled']}>
                    Last Name*
                </label>
            </div>
            <div className={inputStyles["styled-input-container"]}>
                <input
                    id="email"
                    style={{width:"300px"}}
                    value={updatedInfo.email}
                    onChange={handleChange}
                ></input>
                <label className={updatedInfo.email && inputStyles['filled']}>
                    Email*
                </label>
            </div>
            <div style={{display:"flex",width: "300px",justifyContent:"space-between", height:"44px"}}>
                <div style={{position: "relative", width: "125px"}}>
                    <span className={"floating-label"} style={{zIndex:"1"}}>Country Code*</span>
                    <Select
                        options={[...dropdowns.countries]
                            .sort((a, b) => {
                                // If both countries have +1, sort by name
                                if (a.phoneCountryCode === "+1" && b.phoneCountryCode === "+1") {
                                    // Prioritize United States specifically
                                    if (a.name === "United States") return -1;
                                    if (b.name === "United States") return 1;
                                    return a.name.localeCompare(b.name);
                                }
                                // Put +1 countries at the top
                                if (a.phoneCountryCode === "+1") return -1;
                                if (b.phoneCountryCode === "+1") return 1;
                                // Then sort alphabetically by name
                                return a.name.localeCompare(b.name);
                            })
                            .map((code) => ({
                                label: `${code.phoneCountryCode} (${code.name})`,
                                value: code.phoneCountryCode
                            }))}
                        styles={{
                            ...customStyles.popup,
                            container: (provided) => ({
                                ...provided,
                                width: '100%',
                            }),
                        }}
                        value={displayPhoneCountryCode}
                        placeholder='Code*'
                        isSearchable={true}
                        onChange={handlePhoneCountryCode}
                    />
                </div>
                <div className={inputStyles["styled-input-container"]}>
                    <input
                        id="phone"
                        type="number"
                        style={{width:"170px"}}
                        value={updatedInfo.phone}
                        onChange={handleChange}
                    ></input>
                    <label className={updatedInfo.phone && inputStyles['filled']}>
                        Phone Number*
                    </label>
                </div>
            </div>
            <div style={{position: "relative"}}>
                <span className="floating-label">Address Type</span>
                <select
                    className={inputStyles["styled-input-select"]}
                    id="type"
                    style={{width:"300px"}}
                    value={updatedInfo.address.type}
                    onChange={handleAddressChange}
                >
                    <option value="">Address Type</option>
                    {dropdowns.addressType.values.map((type) => (
                        <option key={type.id} value={type.id}>
                            {type.display}
                        </option>
                    ))}
                </select>
            </div>
            <div className={inputStyles["styled-input-container"]}>
                <input
                    id="address1"
                    style={{width:"300px"}}
                    value={updatedInfo.address.address1}
                    onChange={handleAddressChange}
                ></input>
                <label className={updatedInfo.address.address1 && inputStyles['filled']}>
                    Street Address (Ave, St, Blvd, etc.)
                </label>
            </div>
            <div className={inputStyles["styled-input-container"]}>
                <input
                    id="address2"
                    value={updatedInfo.address.address2}
                    onChange={handleAddressChange}
                    style={{width:"300px"}}
                ></input>
                <label className={updatedInfo.address.address2 && inputStyles['filled']}>
                Apartment, Suite, etc
                </label>
            </div>
            <div style={{display:"flex", flexDirection:"column", width: "300px"}}>
                <div className="input-block">
                    <div style={{position: "relative", width: "147px"}}>
                        <span className={"floating-label"} style={{zIndex:"1"}}>Country</span>
                            <Select
                                options={[...dropdowns.countries]
                                    .sort((a, b) => {
                                        // Prioritize United States
                                        if (a.name === "United States") return -1;
                                        if (b.name === "United States") return 1;
                                        // Then sort alphabetically by name
                                        return a.name.localeCompare(b.name);
                                    })
                                    .map((country) => ({
                                        label: country.name,
                                        value: country.code
                                    }))}
                                styles={{
                                    ...customStyles.popup,
                                    container: (provided) => ({
                                        ...provided,
                                        width: '100%',
                                    }),
                                }}
                                value={displayCountry}
                                placeholder='Country'
                                isSearchable={true}
                                onChange={handleCountry}
                            />
                    </div>
                    <div style={{position: "relative", width: "147px"}}>
                        <span className={"floating-label"} style={{zIndex:"1"}}>State/Province</span>
                        <Select
                            options={
                                displayCountry.value
                                    ? dropdowns.countries
                                            .find(country => country.code === displayCountry.value)
                                            ?.states.map(state => ({
                                                label: state.name,
                                                value: state.code
                                            })) || []
                                    : []
                            }
                            styles={{
                                ...customStyles.popup,
                                container: (provided) => ({
                                    ...provided,
                                    width: '100%',
                                }),
                            }}
                            value={displayState}
                            placeholder='State'
                            isSearchable={true}
                            onChange={handleState}
                        />
                    </div>
                </div>
                <div className="input-block" style={{marginBottom:"0px"}}>
                    <div className={inputStyles["styled-input-container"]}>
                        <input
                            id="city"
                            type="text"
                            style={{width:"147px"}}
                            value={updatedInfo.address.city}
                            onChange={handleAddressChange}
                        ></input>
                        <label className={updatedInfo.address.city && inputStyles['filled']}>
                        City
                        </label>
                    </div>
                    <div className={inputStyles["styled-input-container"]}>
                        <input
                            style={{width:"147px"}}
                            type="number"
                            id="zip"
                            value={updatedInfo.address.zip}
                            onChange={handleAddressChange}
                        ></input>
                        <label className={updatedInfo.address.zip && inputStyles['filled']}>
                        Postal Code
                        </label>
                    </div>
                </div>
            </div>
            <div style={{display:"flex",columnGap:"10px"}}>
                <button variant='secondary' disabled={!showUpdateButtons} className={styles.SecondaryButton} onClick={handleCancel} >Cancel</button>
                <button variant='primary' disabled={!showUpdateButtons} className={styles.ModelButton} onClick={handleUpdate} >Save</button>
            </div>
        </div>
    );
}

export default PersonalInfoDetail;